import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Chat from '../components/common/Chat';
import DownloadNotice from "../components/common/DownloadNotice";
import HomeSeoContent, { HOME_FAQS } from '../components/seo/HomeSeoContent';
import Cricket from '../components/sliders/Cricket';
import HomeSliders from "../components/sliders/HomeSliders";
import HotGame from '../components/sliders/HotGame';
import useSEO from '../hooks/useSEO';
import { providerLogoBackgroundImage } from '../utils/providerLogo';
import { buildFaqJsonLd, getSiteBrand, socialProfilesToSameAs } from '../utils/seo';
import Footer from '../layout/Footer';
import Header from "../layout/Header";
import Toolbar from '../navigation/Toobar';


const sections = [
  { title: "Hot Games", icon: "homepageHot.png", type: "HOT" },
    { title: "Sports", icon: "cricket.png", type: "CRICKET" },
    { title: "Casino", icon: "ld.png", type: "LIVE" },
    { title: "Slot", icon: "rng.png", type: "SLOT" },
    { title: "Table", icon: "table.png", type: "TABLE" },
    { title: "Crash", icon: "crash.png", type: "EGAME" },
    { title: "Fishing", icon: "fishing.png", type: "FH" },
    { title: "POKER", icon: "fastgames.png", type: "BINGO" },
    
];


const Home = ({globalData}) => {
 const [activeIndex, setActiveIndex] = useState(0);
    const [systems, setSystems] = useState([]);
    const [providers, setProviders] = useState([]);
    const [setError] = useState(null);
    const [contentPosition, setContentPosition] = useState("0px");
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoggedIn] = useState(!!localStorage.getItem('token')); 
    const [username] = useState(!!localStorage.getItem('username')); 
    const [balance] = useState(!!localStorage.getItem('balance')); 
     const [selectedBrand, setSelectedBrand] = useState('localhost');
    // Base domain for APK naming (strip www and common TLDs)
    const hostname = window.location.hostname.toLowerCase();
    const tldParts = ["com","in","live","net","org","co","io","app","dev","cloud","vip"];
    const segs = hostname.replace(/^www\./,'').split('.');
    while (segs.length > 1 && tldParts.includes(segs[segs.length - 1])) {
      segs.pop();
    }
    const baseDomain = segs[segs.length - 1];

    const siteBrand = globalData?.general?.site_title || getSiteBrand();

    useSEO({
      title: `${siteBrand} – Online Cricket Betting, Live Casino & Slot Games in Bangladesh`,
      description: `Play online cricket betting, live casino and slot games at ${siteBrand}. Deposit in BDT with bKash, Nagad or Rocket, withdraw fast and get 24/7 support in Bangladesh.`,
      keywords: `online betting bangladesh, cricket betting online, live casino bangladesh, online casino, slot games, bKash deposit, Nagad deposit, Rocket deposit, bdt betting site, ${siteBrand}, betting app download`,
      path: '/',
      brand: siteBrand,
      sameAs: socialProfilesToSameAs(globalData?.socialLinks),
      jsonLd: [buildFaqJsonLd(HOME_FAQS)],
    });

      const handleSectionClick = (index) => {
        setActiveIndex(index);
       
    };
     useEffect(() => {
        const selectedSection = sections[activeIndex];
        if (selectedSection.type && selectedSection.type !== "SPORTS") {
            fetchSystems(selectedSection.type);
        } else {
            setSystems([]);
            setProviders([]);
        }
        const isMobileDevice = window.innerWidth <= 768;
        setIsMobile(isMobileDevice);
    }, [activeIndex]);

     useEffect(() => {
    const hostname = (window.location.hostname || '').toLowerCase();
    const origin = (window.location.origin || '').toLowerCase();
    const search = (window.location.search || '').toLowerCase();
    const params = new URLSearchParams(window.location.search);
    const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

    const is2nt666 = hostname.includes('2nt666') || origin.includes('2nt666') || brand.includes('2nt666');
    const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
   
    const selectedBrand = is2nt666 ? '2nt666': isLocalhost ? 'localhost' : 'default';

    localStorage.setItem('brand', selectedBrand);
    setSelectedBrand(selectedBrand);
  
    
  
  
   
  }, []);
    const fetchSystems = async (type) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-system?type=${type}`);
            const data = await response.json();
            if (response.ok) {
                setSystems(data.systems || []);
                fetchProviders(data.systems);
            } else {
                setError(data.message || 'Failed to fetch systems');
            }
        } catch (error) {
            console.error('Error fetching systems:', error);
            setError('An unexpected error occurred while fetching systems');
        }
    };
    const fetchProviders = async (systems) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get-provider?system=${JSON.stringify(systems)}`);
            const data = await response.json();
            if (response.ok) {
                setProviders(data.data || []);
                console.log(data.data);
            } else {
                setError(data.message || 'Failed to fetch providers');
            }
        } catch (error) {
            console.error('Error fetching providers:', error);
            setError('An unexpected error occurred while fetching providers');
        }
    };
        const handleCasinoClick = (system, type, title) => {
        
        navigate(`/games?type=${type}&system=${system}&title=${title}`);
    };
    return (
       
  <div className="v-application--wrap">
    <div>
      <DownloadNotice/>
      <Header/>
      <div className="body">
        <div className="bg_home">
          <HomeSliders slidersMain={globalData.sliders?.main || []} notice={ globalData?.general?.notice || []} />
          <div className="bg_filter">
             {isLoggedIn && (
                <div data-v-49537326 className="balance-details hidden-md-and-up">
  <div data-v-49537326 className="row MB-row pa-3 no-gutters">
    <div data-v-49537326 className="pa-2 pl-0 col col-4">
      <div data-v-49537326 className="row no-gutters"><div data-v-49537326 className="col">{globalData.userData?.username}</div></div>
      <div data-v-49537326 className="row d-flex align-center hidden-md-and-up no-gutters" style={{gap: '5px'}}>
        <div data-v-49537326>
          <label data-v-49537326 className="text-capitalize balance"><span data-v-49537326>৳ {globalData.userData?.balance}</span></label>{/**/}
        </div>
        <div data-v-49537326 className="refresh-balance-icon" />
      </div>
    </div>
    <div data-v-49537326 className="d-flex align-center col col-8">
      <div data-v-49537326 className="row justify-space-around">
        <div data-v-49537326>
          <Link data-v-49537326 to={'/vip'} className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}><img data-v-49537326 src="/static/svg/mobileMemberBalance/bettingPass.svg" className="img-nav-item" /></Link><span data-v-49537326 className="nav-item-span">Big Pass</span>
        </div>
        <div data-v-49537326>
          <Link data-v-49537326 to={'/betting-record'} className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}><img data-v-49537326 src="/static/svg/mobileMemberBalance/betHistory.svg" className="img-nav-item" /></Link><span data-v-49537326 className="nav-item-span">Bet History</span>
        </div>
        {/**/}
        <div data-v-49537326>
          <Link data-v-49537326 to={'/withdrawal'} className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}><img data-v-49537326 src="/static/svg/mobileMemberBalance/withdrawal.svg" className="img-nav-item" /></Link><span data-v-49537326 className="nav-item-span">Withdrawal</span>
        </div>
        <div data-v-49537326>
          <Link data-v-49537326 to={'/deposit'} className="nav-item v-card v-card--link v-sheet theme--dark" tabIndex={0}><img data-v-49537326 src="/static/svg/mobileMemberBalance/deposit.svg" className="img-nav-item" /></Link><span data-v-49537326 className="nav-item-span">Deposit</span>
        </div>
      </div>
    </div>
  </div>
  {/**/}
</div>

)}
            {/**/}
            <div className="game-menu pt-0 pb-4">
              <div>
                <div id="game-menu-full" className="row game-menu-wrapper pb-2 hidden-md-and-up no-gutters">
                  <div className="d-flex col col-12">
                     {sections.map((section, index) => (
                    <div  key={index}  onClick={() => handleSectionClick(index)} className="mx-auto">
                      <div tabIndex={0} className={`v-card v-card--link v-sheet theme--dark game-menu-content font-weight-bold caption ${activeIndex === index ? 'selected' : ''}`} text depressed>
                        <img src={`./icon/${section.icon}`} className="side-menu-icon" />
                        <div className="game-menu-title">{section.title}</div>
                      </div>
                    </div>
                      ))}
                  
                  </div>
                </div>
               

                <hr role="separator" aria-orientation="horizontal" className="v-divider theme--dark" />
                 {sections[activeIndex].type === "HOT" ? (
                  <HotGame  slidersFeatures={globalData.sliders?.feature || []}/>
                ) : sections[activeIndex].type === "CRICKET" ? (
                  <Cricket/>
                ): (
                  <div className="row mt-0 hidden-md-and-up mobile-provider-card-row ld-gap" style={{paddingBottom: '10px'}}>
                     {providers.map((provider, index) => (
                  <div  key={index} onClick={() => handleCasinoClick(provider.platform, sections[activeIndex].type, sections[activeIndex].title )} className="mobile-provider-card-item col gT_rng">
                    <div className="v-image v-responsive banner-img theme--dark sqrBox_img">
                      <div className="v-responsive__sizer" style={{paddingBottom: '100%'}} />
                      <div
                        className="v-image__image v-image__image--contain"
                        style={{
                          backgroundImage: providerLogoBackgroundImage(provider.platform),
                          backgroundPosition: 'center center',
                        }}
                      />
                      <div className="v-responsive__content">
                        {/**/}
                        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
                        {/**/}
                      </div>
                    </div>
                    <span className="rng_providerLabel">{provider.platform}</span>
                  </div>
                  ))}
                
                  
                  
                  
                  <div id="autoFillEle1" className="mobile-provider-card-item gT_rng" style={{maxHeight: '0px !important'}}>
                    <div className="v-image v-responsive banner-img theme--dark" style={{maxHeight: '0px'}}>
                      <div className="v-image__image v-image__image--preload v-image__image--cover" style={{backgroundPosition: 'center center'}} />
                      <div className="v-responsive__content" />
                    </div>
                  </div>
                  <div id="autoFillEle2" className="mobile-provider-card-item gT_rng" style={{maxHeight: '0px !important'}}>
                    <div className="v-image v-responsive banner-img theme--dark" style={{maxHeight: '0px'}}>
                      <div className="v-image__image v-image__image--preload v-image__image--cover" style={{backgroundPosition: 'center center'}} />
                      <div className="v-responsive__content" />
                    </div>
                  </div>
                  <div id="autoFillEle3" className="mobile-provider-card-item gT_rng" style={{maxHeight: '0px !important'}}>
                    <div className="v-image v-responsive banner-img theme--dark" style={{maxHeight: '0px'}}>
                      <div className="v-image__image v-image__image--preload v-image__image--cover" style={{backgroundPosition: 'center center'}} />
                      <div className="v-responsive__content" />
                    </div>
                  </div>
                  {/**/}
                </div>

                )
              }
                {/**/}
              
              </div>
              {/**/}
            </div>
            <div className="pt-2 pb-4">
             
              <div className="row hidden-md-and-up font-weight-bold no-gutters align-end">
                Referrals
              </div>
              <div className="row mx-0 hidden-md-and-up no-gutters justify-center">
                <div className="pt-2 referral-banner col col-12">
                  <div className="v-image v-responsive hidden-md-and-up banner-img theme--dark">
                    <div className="v-responsive__sizer" style={{paddingBottom: '40%'}} />
                    <div className="v-image__image v-image__image--cover" style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}/storage/${globalData.sliders.referral?.[0]?.thubmnail})`, backgroundPosition: 'center center', backgroundSize: 'cover'}} />
                    <div className="v-responsive__content" style={{width: '900px'}} />
                  </div>
                </div>
              </div>
            </div>
            <div data-v-0db96696 className="pt-2 pb-4">
              <div data-v-0db96696 className="row font-weight-bold no-gutters align-end">
                <label data-v-0db96696>Download App</label>
              </div>
              <div data-v-0db96696 className="row mx-0 no-gutters justify-center">
                <div data-v-0db96696 className="pt-2 download-banner col col-12">
                  <div data-v-0db96696 className="v-image v-responsive hidden-sm-and-down banner-img theme--dark">
                    <div className="v-responsive__sizer" style={{paddingBottom: '37.5833%'}} />
                    <div className="v-image__image v-image__image--cover" style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}/storage/${globalData.sliders.download?.[0]?.thubmnail})`, backgroundPosition: 'center center', backgroundSize: 'cover'}} />
                    <div className="v-responsive__content" style={{width: '1200px'}} />
                  </div>
                  <div data-v-0db96696 className="v-image v-responsive hidden-md-and-up banner-img theme--dark">
                    <div className="v-responsive__sizer" style={{paddingBottom: '31.1111%'}} />
                    <div className="v-image__image v-image__image--cover" style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}/storage/${globalData.sliders.download?.[0]?.thubmnail})`, backgroundPosition: 'center center', backgroundSize: 'cover'}} />
                    <div className="v-responsive__content" style={{width: '900px'}} />
                  </div>
                  <div className="text-center mt-2">
                    <a href={`./app/${baseDomain}.apk`} className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default" style={{textDecoration:'none'}}>
                      <span className="v-btn__content">Download App</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row fill-height justify-center"><hr role="separator" aria-orientation="vertical" className="v-divider v-divider--vertical theme--dark" /></div>
            {/**/}
            <div>
              <Link to={'/lucky-spain'}  className="v-image v-responsive wofClass theme--dark" style={{height: '72px', width: '72px'}}>
                <div className="v-responsive__sizer" style={{paddingBottom: '105.521%'}} />
                <div className="v-image__image v-image__image--cover" style={{backgroundImage: 'url("https://jiliwin.9terawolf.com/cms/bigtaka/image/668eb0899634c.gif")', backgroundPosition: 'center center'}} />
                <div className="v-responsive__content" />
              </Link>
            </div>
          </div>
        </div>
        <HomeSeoContent brand={siteBrand} />
        <Footer sociallink={globalData.socialLinks || {}} />
      </div>
      {/**/}
      <Toolbar/>
    
      
      
     <Chat/>
      
    </div>
  </div>

    );
};

export default Home;
